module.exports = __webpack_public_path__ + "static/blog13-f61672557e5873e03662161d7eb9c6ee.png";